import {createBffHooks} from '@product-web/shared--bff-client'

import type {RecurringVendorsRouter} from './index.bff'

export const bffHooks = createBffHooks<RecurringVendorsRouter>()
